<template>
    <Frame>
        <PageHeader :title="$t('salDispatchList.orderSearch')" :hasBack="false" />
        <div class="list-contain">
            <div class="head-contain">

                <div class="filter-contain" style="width: 34%;">
                    <span>{{ $t('salDispatchList.orderDate') }}</span>
                    <el-date-picker v-model="rangeDate" type="daterange" size="small" range-separator="~"
                        :start-placeholder="$t('comm.startdate')" :end-placeholder="$t('comm.enddate')"
                        :picker-options="PickerOptions" :unlink-panels="true" @change="changeTime()">
                    </el-date-picker>
                </div>

                <div class="filter-contain">
                    <span>{{ $t('salDispatchList.orderBillNo') }}</span>
                    <el-input v-model="BillNo" :placeholder="$t('salDispatchList.inputpls')" size="small" clearable></el-input>
                </div>

                <div class="filter-contain">
                    <span>{{ $t('orderImport.customerNoLab') }}</span>
                    <el-input v-model="customerPayNo" :placeholder="$t('salDispatchList.inputpls')" size="small" clearable></el-input>
                </div>

                <div style="width:16%;"> 
                    <span style="width: 100%;display: flex; justify-content: flex-end;">
                        <el-button type="reset" @click="reset()">{{ $t('button.reset') }}</el-button>
                        <el-button type="primary" @click="GetListData(0)">{{ $t('button.query') }}</el-button>
                    </span>
                </div>
            </div>
        </div>
        <el-table ref="multipleTable" :data="tableData" :height="tableHeight" style="margin:0;width:100%"
            v-loading="tableLoading">
            <el-table-column :min-width="WidthControl('BillNo', tableData)" prop="BillNo"
                :label="$t('salDispatchList.BillNo')">
                <template scope="scope">
                    <el-link :underline="false" @click="viewOrderDetail(scope.row)">{{ scope.row.BillNo }}</el-link>
                </template>
            </el-table-column>
            <el-table-column :min-width="WidthControl('BillDate', tableData)" prop="BillDate"
                :label="$t('salDispatchList.BillDate')"></el-table-column>

            <el-table-column min-width="120" prop="TotalSQty"
                :label="$t('salDispatchList.TotalSQty')"></el-table-column>
            <el-table-column :min-width="WidthControl('Address', tableData)" prop="Address"
                :label="$t('salDispatchList.Address')"></el-table-column>
            <el-table-column :min-width="WidthControl('ShortNameString', tableData)" prop="ShortNameString"
                :label="$t('salDispatchList.ShortNameString')"></el-table-column>
            <el-table-column :min-width="WidthControl('X_LogBillNoString', tableData)" prop="X_LogBillNoString"
                :label="$t('salDispatchList.X_LogBillNoString')"></el-table-column>
            <el-table-column :min-width="WidthControl('X_NumberString', tableData)" prop="X_NumberString"
                :label="$t('salDispatchList.X_NumberString')"></el-table-column>
            <el-table-column :label="$t('salDispatchList.operation')">
                <template slot-scope="scope">
                    <el-button class="topbutton" size="mini" type="text" @click="viewOrderDetail(scope.row)">
                        {{ $t('button.check') }}
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="footer-contain">
            <PageSizeChanger :pagesize="pageSize" :afterChange="pageSizeChange"></PageSizeChanger>
            <el-pagination ref="pagination" class="pagination" @current-change="handleCurrentChange"
                layout="total,prev,pager,next,jumper" :pager-count="pagecount" :current-page="currentPage"
                :total="totalCount" :page-size="pageSize">
            </el-pagination>
        </div>

    </Frame>
</template>
<script>
import { listMixin } from '@/agency/mixin/mixin.js'
import { datePickerOptions, handleShortDate } from '@/utils/handleDate'
export default {
    name: 'salDispatchList',
    mixins: [listMixin],
    data() {
        return {
            ProgId: 'salDispatchList',
            PickerOptions: datePickerOptions(this),
            customerPayNo: '',
            tableHeight: window.innerHeight - 260,
            pagecount: 5,
        }
    },
    props: {
        GetListData: {
            type: Function,
            default: function (...arg) {
                this.getListData(...arg);
            }
        }
    },
    mounted() {
        this.frameOnResize(260);
    },
    created() {
        this.rangeDate = this.recentWeeks();
        this.startDate = handleShortDate(this.rangeDate[0], "From");
        this.endDate = handleShortDate(this.rangeDate[1], "To");
        this.GetListData(0);
    },
    methods: {
        recentWeeks() {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            return [start, end];
        },
        changeTime() {
            this.getTime();
            //this.GetListData(0);
        },
        getListData(index) {
            this.pageIndex = index;
            this.tableLoading = true;
            this.axiosInvoke(this.sysHandlerUrl, {
                action: 'getsaldispatchlist',
                BillNo: this.BillNo,
                customerPayNo: this.customerPayNo,
                startDate: this.startDate,
                endDate: this.endDate,
                pageIndex: this.pageIndex,
                pageSize: this.pageSize
            }, (res) => {
                const data = res.data;
                this.tableLoading = false;
                this.tableData = data.DataTable;
                this.totalCount = data.totalCount;
            }, false, true);
        },
        handleCurrentChange(page) {
            this.pageIndex = page - 1;
            this.GetListData(this.pageIndex);
        },
        pageSizeChange() {
            this.GetListData(0);
        },
        viewOrderDetail(row) {
            this.$router.push({
                path: '/Home/SalDispatchListDetail',
                query: {
                    BillNo: row.BillNo
                }
            })
        },
        reset() {
            this.baseReset();
            this.rangeDate = this.recentWeeks();
            this.startDate = handleShortDate(this.rangeDate[0], "From");
            this.endDate = handleShortDate(this.rangeDate[1], "To");
            this.customerPayNo = '';
            this.GetListData(0);
        }
    }
}
</script>
<style scoped>
.list-contain {
    display: flex;
    padding: 20px 0px;
}

.head-contain {
    padding: 0 20px;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
}

.filter-contain {
    width: 23%;
    padding-right: 1%;
    display: flex;
    flex-wrap: nowrap;
}

.filter-contain>span {
    color: black;
    font-size: 14px;
    margin: auto;
    white-space: nowrap;
}

.head-contain > div >span > .el-button{
  padding: 10px 18px;
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
    width: 100%;
}

.el-table{
  font-size: 12px;
  color: black;
}
.el-link{
  font-size: 12px;
}
.el-table /deep/ .el-table__header .cell .el-checkbox:first-child {
    padding-left: 5px;
}

.footer-contain {
    display: flex;
    padding-top: 6px;
    justify-content: center;
}

.pagination {
    padding-top: 4px;
}

.el-table /deep/ th.el-table__cell {
    background-color: #f9f9f9;
}

.el-table /deep/ thead {
    font-size: 14px;
    color: black;
}
</style>
